import React, { useEffect } from 'react';
import { Container, Grid, FormControl, Select, MenuItem } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';
import QueryColumn from '../search/QueryColumn';
import ResultsColumn from '../search/ResultsColumn';
import InfoColumn from '../search/InfoColumn';

const SearchService = () => {
  const { setCurrentContext, mergeCurrentContext } = useGlobal();
  const { selectedIndex, updateSelectedIndex, searchResults } = useBuild();

  useEffect(() => {
    setCurrentContext({
      product: 'build',
      page: 'search',
      source: selectedIndex,
    });
    return () => setCurrentContext(null);
  }, [selectedIndex, setCurrentContext]);

  useEffect(() => {
    const hits = searchResults?.result?.hits;
    const totalHits = searchResults?.result?.total_hits;
    mergeCurrentContext({
      numSearchResults: hits?.length ?? undefined,
      totalSearchHits: totalHits ?? undefined,
    });
  }, [searchResults, mergeCurrentContext]);

  const handleIndexChange = (event) => {
    updateSelectedIndex(event.target.value);
  };

  const indexOptions = [
    { value: 'farcaster-items', label: 'Farcaster Posts' },
    { value: 'farcaster-users', label: 'Farcaster Users' },
    { value: 'zora-coins', label: 'Zora Coins' },
    { value: 'polymarket-items', label: 'Polymarket Markets' },
    { value: 'token-items', label: 'Token Items' },
    { value: 'wallet-users', label: 'Wallet Users' },
    { value: 'polymarket-wallets', label: 'Polymarket Wallets' },
    { value: 'kalshi-items', label: 'Kalshi Markets' },
    { value: 'kalshi-wallets', label: 'Kalshi Wallets' },
    { value: 'dex-notifications', label: 'DEX Notifications' },
    { value: 'polymarket-notifications', label: 'Polymarket Notifications' },
    { value: 'hyperliquid-items', label: 'Hyperliquid Markets' },
    { value: 'hyperliquid-notifications', label: 'Hyperliquid Notifications' },
    { value: 'hyperliquid-wallets', label: 'Hyperliquid Wallets' },
    { value: 'hyperliquid-wallet-positions', label: 'Hyperliquid Wallet Positions' },
    { value: 'hyperliquid-trades', label: 'Hyperliquid Trades' },
    { value: 'polymarket-trades', label: 'Polymarket Trades' },
    { value: 'base-trades', label: 'Base Trades' },
    { value: 'ethereum-trades', label: 'Ethereum Trades' },
    { value: 'solana-trades', label: 'Solana Trades' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 120px)' }}>
        {/* Index Selection */}
        <Grid size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth variant="outlined" size="small" sx={{ mb: 2 }}>
            <Select
              value={selectedIndex}
              onChange={handleIndexChange}
              sx={{ 
                bgcolor: 'background.paper',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: 'background.paper',
                  },
                },
              }}
            >
              {indexOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Query Column */}
          <QueryColumn />
        </Grid>
        
        {/* Results Column */}
        <Grid size={{ xs: 12, md: 6 }}>
          <ResultsColumn />
        </Grid>
        
        {/* Info Column */}
        <Grid size={{ xs: 12, md: 2 }}>
          <InfoColumn />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SearchService;
